import { FilterTypesEnum } from '../FilterTypesEnum';
import { FilterModel } from './filter.model';

export class StringBiggerFilterModel extends FilterModel {
  override symbol: FilterTypesEnum = FilterTypesEnum.string_bigger;

  isValid() {
    return !!this.value;
  }
}
